<template>
  <div>
    <div class="has-content-margin select-no-data" v-if="!team.id || team.id === ''">
      暂无选择队伍或工人
    </div>
    <div class="has-content" v-else>
      <div>
        <div class="select-info">
          <div class="select-label">已选中队伍信息</div>
          <f7-link class="select-button" @click="reassign" v-if="perms.projectEntrust">
            重新指派
          </f7-link>
        </div>
        <div class="team-item">
          <div class="team-text">
            <div style="display: flex; align-items: center;">
              <div style="flex: auto;">
                <div class="divider">&nbsp;</div>
              </div>
              <div style="padding: 0rem 1rem;">
                {{ team.companyName }}
              </div>
              <div>
                <img src=''/>
              </div>
              <div style="flex: auto;">
                <div class="divider">&nbsp;</div>
              </div>
            </div>
            <div style="display: flex;">
              <div class="team-text-sub">
                <div style="padding: 0.5rem 0rem; display: flex; flex-wrap: wrap;">
                  <!-- <div class="team-text-type">
                    {{ (team.features || [] ).map(sa => sa.attrValueDesc).join('/') }}&nbsp;
                  </div> -->
                  <div
                    class="team-text-type"
                    v-for="sa in (team.features || [] )"
                    :key="sa.attrValue">
                    {{ sa.attrValueDesc }}
                  </div>
                </div>
                <f7-row no-gap>
                  <f7-col>
                    <span class="team-text-label">工人</span>
                    <span class="team-text-value">{{ team.companyScale || '--' }} &nbsp;</span>
                    <span class="team-text-label">当前任务</span>
                    <span class="team-text-value">{{ team.taskCount || 0 }} &nbsp;</span>
                    <span class="team-text-label">地区</span>
                    <span class="team-text-value">
                      {{ (team.serviceArea || []).map(sa => sa.attrValueDesc).join(',') }}
                    </span>
                  </f7-col>
                </f7-row>
              </div>
              <div class="team-after">
                <div style="width: 3.5rem;">
                  <f7-link :href="`tel:${team.contactpeoplePhone}`">
                    <span class="team-phone">
                      <span style="color: #000000; font-size: 1rem;">
                        {{ team.contactpeopleName }}
                      </span>
                      <f7-icon size="2rem" fa="phone"></f7-icon>
                    </span>
                  </f7-link>
                </div>
              </div>
            </div>
            <div class="divider" style="padding-top: 1.5rem;">&nbsp;</div>
            <div class="radar-area">
              <echarts
                :options="radarData"
                ref="radarGraph"
                :auto-resize="true"
                style="text-align: center; width: 100%; height: 260px;">
              </echarts>
            </div>
          </div>
        </div>
        <f7-list
          media-list
          virtual-list
          accordion-list>
          <f7-list-item
            accordion-item
            :accordion-item-opened="rangeExpanded"
            @accordion:close="rangeExpanded=false"
            @accordion:open="rangeExpanded=true">
            <div slot="inner" class="accordion-item-title">
               <div>业务范围</div>
               <div><f7-icon :fa="rangeExpanded?'angle-up':'angle-right'"></f7-icon></div>
            </div>
            <f7-accordion-content>
              <div
                class="scope-info"
                v-for="item in team.domainRange"
                :key="item.attrValue">
                  {{ item.attrValueDesc }}
              </div>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>
        <f7-list
          media-list
          virtual-list
          accordion-list>
          <f7-list-item
            accordion-item
            :accordion-item-opened="historyExpanded"
            @accordion:close="historyExpanded=false"
            @accordion:open="historyExpanded=true">
            <div slot="inner" class="accordion-item-title">
               <div>历史业绩</div>
               <div><f7-icon :fa="historyExpanded?'angle-up':'angle-right'"></f7-icon></div>
            </div>
            <f7-accordion-content>
              <div
                class="timeline-item"
                v-for="item in team.projectInfoHistoryVoList"
                :key="item.id"
                style="align-items: center;">
                <div class="timeline-item-date" style="width: 1rem; padding-top: 0.2rem;">
                </div>
                <div class="timeline-item-divider custom-divider">
                  <div class="divider-icon-check">
                    <f7-icon fa="check-circle" size="1.75rem"></f7-icon>
                  </div>
                </div>
                <div class="timeline-item-content" style="padding-top: 0.2rem;">
                  <div class="timeline-item-title">{{ item.name }}</div>
                  <div class="timeline-item-time" style="margin-top: 0rem;">
                    {{ item.realCompletedTime | formatDateValue }}
                    至
                    {{ item.realStartupTime | formatDateValue }}
                  </div>
                  <div class="timeline-item-time" style="margin-top: 0rem;">
                    {{ item.address }}
                  </div>
                </div>
              </div>
            </f7-accordion-content>
          </f7-list-item>
        </f7-list>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';
import { getTeam, reassignTeam } from '@/api/team/worker';
import { dateFormat } from '@/util/dateUtils';
import bus from '@/util/bus';

Vue.component('echarts', ECharts);

export default {
  props: ['projectId', 'perms'],
  data() {
    return {
      rangeExpanded: false,
      historyExpanded: false,
      team: {},
      radarData: {},
    };
  },
  created() {
    bus.$on('refreshAssign', () => {
      this.getInfo();
    });
  },
  mounted() {
    this.getInfo();
  },
  filters: {
    formatDateValue: value => dateFormat(value),
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getInfo()]).then(() => done());
    },
    reassign() {
      this.$f7.dialog.confirm(`确认重新指派吗？<br>
      <div style="text-align: left;">
      确认后将删除已经指派队伍或工人，并同时删除以下信息：<br>
      -已经签订的合同信息<br>
      -施工日志信息<br>
      -各种验收信息<br>
      -评价信息<br>
      -各种消息/通知/群成员信息<br><br>
      <div>`, '温馨提示', () => {
        reassignTeam({ projectId: this.projectId }).then((result) => {
          if (result.code === 0) {
            bus.$emit('refreshAssign');
            this.getInfo();
          }
        });
      });
    },
    getInfo() {
      getTeam({ projectId: this.projectId }).then((result) => {
        if (result.code === 0) {
          this.team = result.data || {};
          this.getRadarData();
        }
      });
    },
    getRadarData() {
      const radarOption = {
        title: {
          text: this.team.score,
          left: 'center',
          top: '50%',
          textStyle: {
            color: '#0ab15f',
            fontSize: 32,
          },
        },
        radar: [{
          splitNumber: 4,
          name: {
            textStyle: {
              color: '#333333',
            },
          },
          splitArea: {
            areaStyle: {
              color: ['#FFFFFF'],
              // shadowColor: 'rgba(0, 0, 0, 0.3)',
              // shadowBlur: 10,
            },
          },
          axisLine: {
            lineStyle: {
              color: '#D3D3D3',
            },
          },
          splitLine: {
            lineStyle: {
              color: '#D3D3D3',
            },
          },
          indicator: [
            { text: '从业年限', max: 100 },
            { text: '行为评分', max: 100 },
            { text: '业绩积累', max: 100 },
            { text: '规模实力', max: 100 },
            { text: '信用荣誉', max: 100 },
          ],
          center: ['50%', '58%'],
          radius: 110,
        }],
        series: [{
          type: 'radar',
          tooltip: {
            trigger: 'item',
          },
          data: [{
            value: [
              this.team.workAgeItem,
              this.team.evaluateItem,
              this.team.performanceItem,
              this.team.scaleItem,
              this.team.creditItem,
            ],
            name: this.team.companyName,
            lineStyle: {
              normal: {
                width: 1,
                opacity: 0.8,
              },
            },
            itemStyle: {
              normal: {
                color: '#A2E4C4',
              },
            },
            areaStyle: {
              normal: {
                opacity: 0.6,
              },
            },
          }],
        }],
      };
      this.radarData = radarOption;
      return radarOption;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .select-no-data {
    border-radius: 0.5rem;
    background-color: $panel-bg-color;
    text-align: center;
    line-height: 8rem;
    height: 8rem;
    font-size: 1rem;
    padding: 0rem 10px;
    color: #B6B6B6;
  }

  .select-info {
    padding: 0rem 0.5rem;
    line-height: 2rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    background-color: #CAE8EA;
  }

  .select-label {
    color: $font-color;
    flex: auto;
  }

  .select-button {
    color: #787878;
  }

  .divider {
    flex: auto;
    height: 0.01rem;
    padding-top: 0.5rem;
    border-bottom: 0.05rem solid $border-color;
  }

  .team-item {
    font-size: 1rem;
    display: flex;
    align-items: center;
    width: 100%;
    padding-top: 1rem;
  }

  .team-item-type {
    font-size: 1rem;
    display: flex;
    align-items: center;
    width: 100%;
  }

  .team-text {
    font-size: 1rem;
    width: 100%;
  }

  .team-text-sub {
    font-size: 0.8rem;
    flex: auto;
  }

  .team-text-type {
    background-color: #FEF2DE;
    border-radius: 0.3rem;
    padding: 0.2rem 0.2rem;
    margin: 0.2rem 0.5rem 0rem 0rem;
    color: #FF9403;
  }

  .team-text-label {
    color: $second-font-color;
  }

  .team-text-value {
    color: #FF9403;
    word-wrap: break-word;
    word-break: break-all;
  }

  .team-after {
    display: flex;
    align-items:center;
    justify-content:center;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    color: #FF9403;
    font-size: 0.6rem;
    text-align: center;
  }

  .team-phone {
    color: $second-color;
  }

  .accordion-item-title {
    display: flex;
    justify-content: space-between;
    margin: 0rem 0rem;
    padding: 0.5rem 0.5rem;
    background-color: $panel-bg-color;
    color: $second-font-color;
  }

  .accordion-item .item-content {
    background-color: #8e8e93;
    padding-left: 0rem;
  }

  .scope-info {
    padding-left: 0.5rem;
    line-height: 1.6rem;
    height: 1.6rem;
  }

  .scope-sub {
    line-height: 1.5rem;
    height: 1.5rem;
    color: $second-font-color;
    font-size: 0.6rem;
  }

  .radar-area {
    position: relative;
    width: 100%;
  }

  .radar-area-score {
    color: $font-color;
    height: 1rem;
    width: 1rem;
    line-height: 1rem;
    position: absolute;
    left: 0.5rem;
    top: 1rem;
    text-align: center;
  }

  .custom-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.5rem;
    height: 1.5rem;
  }

  .divider-icon-check {
    width: 100%;
    height: 100%;
    background-color: $white-color;
    color: #80C269;
  }

</style>



// WEBPACK FOOTER //
// src/pages/team/assignTeam.vue